(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ssLayerBound) return;
    window.__ssLayerBound = true;

    document.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-ss-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: btn.dataset.ssAdd, quantity: 1 })
        });
        if (!res.ok) throw new Error('add failed');

        var comp = document.querySelector('cart-items-component');
        var sid = comp && comp.dataset ? comp.dataset.sectionId : null;
        if (sid) {
          var sr = await fetch(window.location.pathname + '?sections=' + sid, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          var sd = await sr.json();
          if (typeof window.manualCartRefresh === 'function') {
            await window.manualCartRefresh({ sections: sd });
          } else {
            document.dispatchEvent(new CustomEvent('theme:cart:update', {
              bubbles: true,
              detail: { data: { sections: sd } }
            }));
          }
        } else {
          window.location.reload();
        }
      } catch (err) {
        console.error('[ss-layer]', err);
        btn.disabled = false;
        btn.textContent = label;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ssCardBound) return;
    window.__ssCardBound = true;

    var KEY = 'shopify_wishlist';

    function getList() {
      try {
        var raw = localStorage.getItem(KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) { return []; }
    }
    function saveList(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function updateCount() {
      var count = getList().length;
      ['wishlist-header-count', 'wishlist-header-count-mob'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.textContent = count;
        el.style.setProperty('display', 'flex', 'important');
      });
    }
    function sync() {
      var ids = getList().map(function (p) { return String(p.id); });
      document.querySelectorAll('.ss-card__wish').forEach(function (btn) {
        var on = ids.indexOf(String(btn.dataset.productId)) !== -1;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ss-card__wish');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = String(btn.dataset.productId || '');
      if (!id) return;
      var list = getList();
      var i = list.findIndex(function (p) { return String(p.id) === id; });
      if (i === -1) {
        list.push({
          id: id,
          title: btn.dataset.productTitle || '',
          url: btn.dataset.productUrl || '',
          image: btn.dataset.productImage || '',
          price: btn.dataset.productPrice || ''
        });
      } else {
        list.splice(i, 1);
      }
      saveList(list);
      sync();
      updateCount();
    }, true);

    window.ssCardSync = sync;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    window.addEventListener('load', sync);
    window.addEventListener('pageshow', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ssCardBound) return;
    window.__ssCardBound = true;

    var KEY = 'shopify_wishlist';

    function getList() {
      try {
        var raw = localStorage.getItem(KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) { return []; }
    }
    function saveList(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function updateCount() {
      var count = getList().length;
      ['wishlist-header-count', 'wishlist-header-count-mob'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.textContent = count;
        el.style.setProperty('display', 'flex', 'important');
      });
    }
    function sync() {
      var ids = getList().map(function (p) { return String(p.id); });
      document.querySelectorAll('.ss-card__wish').forEach(function (btn) {
        var on = ids.indexOf(String(btn.dataset.productId)) !== -1;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ss-card__wish');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = String(btn.dataset.productId || '');
      if (!id) return;
      var list = getList();
      var i = list.findIndex(function (p) { return String(p.id) === id; });
      if (i === -1) {
        list.push({
          id: id,
          title: btn.dataset.productTitle || '',
          url: btn.dataset.productUrl || '',
          image: btn.dataset.productImage || '',
          price: btn.dataset.productPrice || ''
        });
      } else {
        list.splice(i, 1);
      }
      saveList(list);
      sync();
      updateCount();
    }, true);

    window.ssCardSync = sync;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    window.addEventListener('load', sync);
    window.addEventListener('pageshow', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
